window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600
  }
});

const isCustomerPortal = window.location.pathname.includes("/tools/bundle-subscriptions") && window.location.search.includes("subscriptionId=");
const isBaBPurchaseFlow = window.location.pathname.includes("/tools/bundle-subscriptions/bundle/");

const waitForElement = (selector, callback, delay = 0, failsafeDelay) => {
  const observer = new MutationObserver((mutations, obs) => {
    const element = document.querySelector(selector);
    if (element) {
      obs.disconnect();
      if (typeof callback === "function") {
        setTimeout(() => {
          callback(element);
        }, delay);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (failsafeDelay) setTimeout(() => observer.disconnect(), failsafeDelay);
};

document.body.addEventListener("click", async (event) => {
  if (!event.target.matches(".cart__remove-bundle *, .cart__remove-bundle[data-bundle-id]")) return;

  const bundleElement = event.target.closest(".cart__remove-bundle") || (event.target.hasAttribute("data-bundle-id") ? event.target : null);
  const bundle_id = bundleElement ? bundleElement.getAttribute("data-bundle-id") : null;

  if (bundle_id) {
    event.preventDefault();
    try {
      // Get current cart contents
      const cart = await (await fetch("/cart.js")).json();

      // Create data object for cart update AJAX call
      const data = {
        updates: cart.items.reduce((acc, item) => (item.properties?._bundleUid == bundle_id ? { ...acc, [item.key]: 0 } : acc), {})
      };

      // API call to update the cart contents and set the bundle item quantities to 0
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });

      response.ok && (window.location.href = "/cart");
    } catch (error) {
      console.error(error);
    }
  }
});

if (isBaBPurchaseFlow) {
  waitForElement(".bundle-container", (stepper) => {
    const newStepper = `
    <div class="bundle-new-stepper-wrapper">
      
      <div class="bundle-new-stepper">
        <div>
          
          <h4>Step 1: Select Your Wines</h4>
          <p>Custmize your shipment to fit your taste.</p>
        </div>
        <div>
         
          <h4>Step 2: Select Your Add-Ons</h4>
          <p>Add Clif Family artisan foods to compliment your order.</p>
        </div>
        <div>
          
          <h4>Step 3: Confirm Your Shipment</h4>
          <p>Sit back and relax, we'll take care of the rest!</p>
        </div>
      </div>
    </div>
    `;
    stepper.insertAdjacentHTML("beforebegin", newStepper);

    document.querySelectorAll(".bundle-scrollable-section").forEach((section) => section.classList.remove("bundle-scrollable-section"));

    const completeScreen = document.querySelector(".bundleapp-modal__container--complete-screen");
    if (completeScreen) {
      completeScreen.classList.add("bundle-scrollable-section");
    }

    //hack every click of nav.bundle-section__nav > button
    document.querySelectorAll("nav.bundle-section__nav > button").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();

        const targetId = button.getAttribute("aria-controls");
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          const scrollableElement = document.querySelector(".bundle-scrollable-section");
          setTimeout(() => {
            let offset = document.querySelector(".bundle-new-stepper-wrapper") ? document.querySelector(".bundle-new-stepper-wrapper").offsetHeight : 0;
            if (offset != 0) offset = offset + 50;
            scrollableElement.scrollTo({
              top: targetElement.offsetTop + offset + 20,
              behavior: "smooth"
            });
          }, 1);
        }
      });
    });

    //hide options container if no options (or only 1)
    waitForElement(".awtomatic-sizes-container", (sizesContainer) => {
      if (sizesContainer.children.length <= 1) {
        sizesContainer.style.display = "none";
      }
    });

    waitForElement(".awtomatic-plans-container", (plansContainer) => {
      if (plansContainer.children.length <= 1) {
        plansContainer.style.display = "none";

        const previousElement = plansContainer.previousElementSibling;
        if (previousElement && previousElement.tagName.toLowerCase() === "span" && previousElement.classList.contains("bundle-text--subheading")) {
          previousElement.style.display = "none";
        }
      }
    });
  });
}
